export const normalizeExternalUrl = (url: string) => {
    const trimmedUrl = url.trim();
    if (!trimmedUrl) return '';

    return /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
};

const buildBigCommerceStoreUrl = (storeHash: string) => {
    const hash = storeHash.trim();
    if (!hash) return '';
    if (/^https?:\/\//i.test(hash)) return hash;
    if (hash.includes('.')) return normalizeExternalUrl(hash);

    return `https://store-${hash.replace(/^store-/, '')}.mybigcommerce.com`;
};

export const getSalesChannelUrl = (ecommerceName: string, definitiveUrl: string, remoteUrl: string) => {
    if (ecommerceName === 'BIG_COMMERCE') {
        if (/^https?:\/\//i.test(definitiveUrl)) return definitiveUrl;
        if (definitiveUrl.includes('.')) return normalizeExternalUrl(definitiveUrl);
        return buildBigCommerceStoreUrl(remoteUrl || definitiveUrl);
    }

    return normalizeExternalUrl(definitiveUrl || remoteUrl);
};

export const formatStoreUrl = (url: string) => url.replace(/^https?:\/\//, '').replace(/\/$/, '');
